import { render, staticRenderFns } from "./dashboardTaocanzhanbi.vue?vue&type=template&id=604bc36c&scoped=true"
import script from "./dashboardTaocanzhanbi.vue?vue&type=script&lang=js"
export * from "./dashboardTaocanzhanbi.vue?vue&type=script&lang=js"
import style0 from "./dashboardTaocanzhanbi.vue?vue&type=style&index=0&id=604bc36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604bc36c",
  null
  
)

export default component.exports